class MediaVideo extends HTMLElement {
  videoPanel: HTMLDivElement | null = null;
  playButton: HTMLDivElement | null = null;

  constructor() {
    super();
    this.playButton = this.querySelector('#play-button');
    this.videoPanel = this.querySelector('#video-panel');

    if (!this.playButton) return;
    this.playButton.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();

    this.playButton?.classList.remove('z-[2]');
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);

      this.videoPanel?.classList.remove('hidden');
      this.videoPanel?.classList.add('block');
      const deferredElement = this.videoPanel.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

if (!customElements.get('media-video')) {
  customElements.define('media-video', MediaVideo);
}
